var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBulkNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/bulk/notification"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 5a3 3 0 11-3-3 3 3 0 013 3z",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M19 9.5A4.507 4.507 0 0114.5 5a4.51 4.51 0 01.49-2H7.52C4.07 3 2 5.06 2 8.52v7.95C2 19.94 4.07 22 7.52 22h7.95c3.46 0 5.52-2.06 5.52-5.52V9.01A4.434 4.434 0 0119 9.5z",
    fill: "#d4dde4"
  }))));
}
export default SvgVuesaxBulkNotification;